import { render, staticRenderFns } from "./PrintShopConfig.vue?vue&type=template&id=2ce454c0&"
import script from "./PrintShopConfig.vue?vue&type=script&lang=js&"
export * from "./PrintShopConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports